import { scrollbar } from './scrollbar';

export const global = () => ({
    body: {
        overflow: 'hidden'
    },
    ...scrollbar
});
